/* ============================================================
   URINKING · Trust-Leiste, selbsttaetiger Wechsel
   Angelegt 31.07.2026

   [01.10.2026] UMGEBAUT: kein Scroll-Container mehr (Grund in
   uk-trust.css). Das Skript schaltet die Klasse ist-aktiv um -
   per Timer, per Pfeil und per Wischgeste. Faellt es aus, steht
   die erste Angabe da.

   Es laeuft NUR, wenn drei Bedingungen zutreffen:
     1. Die Leiste steht auf "durchwischen" (data-auto)
     2. Der Schirm ist schmal genug, dass die Wisch-Variante greift
     3. Der Besucher hat Bewegung nicht reduziert (harte Regel 13)

   Es pausiert, sobald jemand selbst wischt oder die Leiste
   beruehrt, und wenn der Tab im Hintergrund liegt - sonst laeuft
   ein Timer weiter, den niemand sieht.
   ============================================================ */

(function () {
  'use strict';

  var SCHMAL = '(max-width: 749px)';
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var schmal = window.matchMedia(SCHMAL);

  function starte(leiste) {
    // [02.10.2026] Laeuft dieses Skript zweimal (Leiste im Kopf UND eine
    // zweite uk-trust-Section auf der Seite laden es je einmal), bekaeme
    // jede Leiste zwei Timer und zwei Pfeil-Handler: Sie sprang um zwei
    // Angaben, die Haelfte war nie zu sehen. Eine Leiste startet einmal.
    if (leiste.dataset.ukAn) { return; }
    leiste.dataset.ukAn = '1';
    var reihe = leiste.querySelector('.uk-trust__reihe');
    if (!reihe) { return; }
    var angaben = reihe.querySelectorAll('.uk-trust__angabe');
    if (angaben.length < 2) { return; }

    var tempo = parseFloat(getComputedStyle(leiste).getPropertyValue('--uk-trust-tempo')) || 4;
    var auto = leiste.dataset.auto === 'true';
    var uhr = null;
    var pausiert = false;

    function darfLaufen() {
      return auto && schmal.matches && !ruhig.matches && !pausiert && !document.hidden;
    }

    // Springt um eine Angabe weiter und laeuft dabei um: hinter der
    // letzten kommt wieder die erste. Deshalb sind die Pfeile nie
    // ausgegraut - ein deaktivierter Knopf an einer dreiteiligen
    // Leiste wirkt wie ein Fehler.
    var aktiv = 0;
    function zeige(i) {
      angaben[aktiv].classList.remove('ist-aktiv');
      aktiv = i;
      angaben[aktiv].classList.add('ist-aktiv');
    }
    leiste.classList.add('ist-bereit');
    zeige(0);

    function springe(richtung) {
      var ziel = aktiv + richtung;
      if (ziel >= angaben.length) { ziel = 0; }
      if (ziel < 0) { ziel = angaben.length - 1; }
      zeige(ziel);
    }

    // Wischen: waagerechte Bewegung ueber 40 px schaltet um.
    var startX = null;
    reihe.addEventListener('pointerdown', function (e) { startX = e.clientX; }, { passive: true });
    reihe.addEventListener('pointerup', function (e) {
      if (startX === null) { return; }
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) { springe(dx < 0 ? 1 : -1); }
    }, { passive: true });

    function weiter() {
      if (!darfLaufen()) { return; }
      springe(1);
    }

    var zurueck = leiste.querySelector('.uk-trust__pfeil--zurueck');
    var vor = leiste.querySelector('.uk-trust__pfeil--vor');
    if (zurueck) { zurueck.addEventListener('click', function () { springe(-1); }); }
    if (vor)     { vor.addEventListener('click', function () { springe(1); }); }

    function an() {
      aus();
      if (!darfLaufen()) { return; }
      uhr = window.setInterval(weiter, tempo * 1000);
    }
    function aus() {
      if (uhr) { window.clearInterval(uhr); uhr = null; }
    }

    // Wer selbst wischt oder die Leiste beruehrt, will lesen -
    // dann nicht darunter wegschalten.
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (e) {
      leiste.addEventListener(e, function () { pausiert = true; aus(); }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      leiste.addEventListener(e, function () { pausiert = false; an(); }, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { aus(); } else { an(); }
    });

    if (typeof schmal.addEventListener === 'function') {
      schmal.addEventListener('change', an);
      ruhig.addEventListener('change', an);
    }

    an();
  }

  // ALLE Leisten, nicht nur die mit selbsttaetigem Wechsel: Die Pfeile
  // muessen auch dann funktionieren, wenn der Wechsel abgeschaltet ist.
  // Ob der Timer laeuft, entscheidet darfLaufen().
  function alle() {
    var leisten = document.querySelectorAll('.uk-trust');
    Array.prototype.forEach.call(leisten, starte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle, { once: true });
  } else {
    alle();
  }

  // Der Theme-Editor baut Sektionen neu auf, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.uk-trust')) { alle(); }
  });
})();
